import * as React from "react";
import { ResponsiveContainer, Pie, PieChart, Tooltip, Legend, Cell } from "recharts";
import { CustomTooltip } from "../CustomTooltip/CustomTooltip";
import { useColorsCicleChart } from "src/share/hooks/useCircleChartColors";

const CircleChart: React.SFC<any> = ({ data }) => {
	const [circleChartColors] = useColorsCicleChart(data);
	return (
		<ResponsiveContainer width={"100%"} height={310}>
			<PieChart>
				<Pie cx="50%" cy="50%" innerRadius={90} outerRadius={120} fill="#8884d8" paddingAngle={5} dataKey={"count"} data={data}>
					{data.map((entry, index) => <Cell key={index} fill={data.length > 0 ? circleChartColors[index % circleChartColors.length] : "#F3F3F3"} />)}
				</Pie>
				<Tooltip content={<CustomTooltip />} />
				<Legend align="center" verticalAlign="bottom" layout="horizontal" />
			</PieChart>
		</ResponsiveContainer>
	);
}


export default CircleChart;



// WEBPACK FOOTER //
// ./src/share/components/Chart/CircleChart.tsx